import React, { Component } from 'react';
import PageTreeCB from '~/components/CheckBox/PageTreeCB';
export default class Second extends Component {
  render () {
    const { data = {}, isBottom = false, value = [], onChange, disabled = false, marginLeft = 30 } = this.props;
    const list = data.list || [];
    return (
      <div style={{ display: 'flex', position: 'relative', flexDirection: 'column', marginLeft }}>
        <div style={{ display: 'flex' }}>
          <div style={{ height: 3, width: 40, backgroundColor: 'black', marginTop: 9 }} />
          <PageTreeCB disabled={disabled} value={value.indexOf(data.id) > -1} onClick={() => onChange([data.id])} />
          <div style={{ fontSize: 16, marginLeft: 5 }}>{data.name}</div>
        </div>
        {list.map((o, i) => <Second disabled={disabled} key={i} data={o} isBottom={list.length === i + 1} value={value} onChange={onChange} marginLeft={marginLeft + 20} />)}
        <div style={{ height: 5 }} />
        <div style={{ position: 'absolute', width: 3, height: isBottom ? 10 : '100%', backgroundColor: 'black' }} />
      </div>
    );
  }
}
